import {
  AssignmentResponseDetail,
  AssignmentResponseNavigation,
} from "../../pages/AssignmentResponseDetailPage/AssignmentResponseDetailPage.types";
import axiosInstance from "../axiosConfig";
import { AssignmentResponseData, AssignmentReviewCreateData } from "./assignmentResponseService.types";

import { logger } from "utils/logger";

export const fetchAssignmentResponses = async (
  page: number = 1,
  pageSize: number = 10,
  ordering: string = "",
): Promise<AssignmentResponseData> => {
  const url = `/courses/assignment-responses/`;
  const response = await axiosInstance.get<AssignmentResponseData>(url, {
    params: { page, page_size: pageSize, ordering },
  });
  return response.data;
};

export const fetchAssignmentResponseById = async (id: number): Promise<AssignmentResponseDetail> => {
  const url = `/courses/assignment-responses/${id}/`;
  const response = await axiosInstance.get<AssignmentResponseDetail>(url);
  return response.data;
};

export const fetchAssignmentResponseNavigation = async (
  id: number,
): Promise<AssignmentResponseNavigation> => {
  const url = `/courses/assignment-responses/${id}/navigation/`;
  const response = await axiosInstance.get<AssignmentResponseNavigation>(url);
  return response.data;
};

export const createAssignmentReview = async (data: AssignmentReviewCreateData): Promise<void> => {
  const url = `/student/create-assignment-review/`;
  try {
    await axiosInstance.post(url, data);
    logger.log("Фидбек успешно отправлен");
  } catch (error) {
    logger.error("Ошибка при отправке фидбека:", error);
    throw error;
  }
};

export interface AssignmentRevisionData {
  response: number;
  teacher_comments: string;
}

export const createAssignmentRevision = async (
  data: AssignmentRevisionData,
): Promise<void> => {
  const url = "/student/create-assignment-review/";
  try {
    await axiosInstance.post(url, data);
    logger.log("Запрос доработки отправлен");
  } catch (error) {
    logger.error("Ошибка при отправке запроса доработки:", error);
    throw error;
  }
};
